// extracted by mini-css-extract-plugin
export default {"card":"Card_card__cQH9t","title":"Card_title__Mr7bR","types":"Card_types__Fs-ZL"};